import { render, staticRenderFns } from "./common-compose.vue?vue&type=template&id=bf3f003c&scoped=true&"
import script from "./common-compose.vue?vue&type=script&lang=ts&"
export * from "./common-compose.vue?vue&type=script&lang=ts&"
import style0 from "./common-compose.vue?vue&type=style&index=0&id=bf3f003c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3f003c",
  null
  
)

export default component.exports